exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DVRNoAnswerPopup_controls_3EbZ {\n  margin: 0 auto;\n\n  max-width: 300px;\n\n  text-align: center;\n}\n\n.DVRNoAnswerPopup_button_SvPz {\n  margin-bottom: 30px;\n}\n\n@media (max-width: 767px) {\n\n  .DVRNoAnswerPopup_button_SvPz {\n    padding: 0 20px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"controls": "DVRNoAnswerPopup_controls_3EbZ",
	"button": "DVRNoAnswerPopup_button_SvPz"
};